import { useCallback } from 'react'
import usePersistentState from '../../hooks/usePersistentState'

const useTreeLeafSelectCtrl = <T extends string | number>(treeKey: string, defaultSelected: T) => {
  const [selected, setSelected] = usePersistentState(
    { selectedItem: defaultSelected },
    treeKey + '/selected',
    'localstorage'
  )

  const handleSelect = useCallback(
    (item: T) => {
      setSelected({ selectedItem: item })
    },
    [setSelected]
  )

  return { selectedItem: selected.selectedItem, handleSelect }
}

export default useTreeLeafSelectCtrl
